module.exports = require("react-collapse");


//////////////////
// WEBPACK FOOTER
// external "react-collapse"
// module id = 282
// module chunks = 0